/**
 * @title TradeIn Completed Page - Drop-Off dialog
 * @description The consumer gets a list of drop-off points for their trade-in
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/dropoff-points.png
 */
import * as React from "react";
import {DropOffFragment} from "../../../Queries";
import {Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, useMediaQuery, useTheme} from "@mui/material";
import {StyledTypography} from "../../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {CloseIcon} from "../../../svg/SvgIcons";
import {ComputerIcon, QRIcon} from "../../../components/Icons";

type DropOffParams = {
   dropOffs: DropOffFragment[]
   open: boolean
   onHide: () => void
   showQr: boolean
};
export const Dropoff = (props: DropOffParams) => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [hide] = React.useState<boolean>(false);
   const theme = useTheme();
   const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
   const classes = useStyles();

   return <Dialog onClose={props.onHide} maxWidth={"sm"} fullScreen={!isDesktop} open={props.open && !hide}
                  style={{width: '100%'}}>
      <DialogTitle sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
         <div style={{width: '100%', textAlign: 'center'}}>
            <StyledTypography variant={"h1"}>{localizations.consumerDropoffTitle}</StyledTypography>
         </div>
         <IconButton onClick={props.onHide}>
            <CloseIcon/>
         </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
         <div className={classes.box}>
            {props.dropOffs.map(drop => {
               return <Box key={drop.name} sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                  <Box>
                     <StyledTypography variant={"body1"} sx={{fontWeight: 'bold'}}>{drop.name}</StyledTypography>
                     <StyledTypography variant={"body1"}>{drop.address}</StyledTypography>
                     <StyledTypography variant={"body1"}>{drop.address2}</StyledTypography>
                     <StyledTypography variant={"body1"}>{drop.zipcode} {drop.city}</StyledTypography>
                  </Box>
                  <Box>
                     {props.showQr && drop?.qr_code &&
                        <QRInfoPopper>
                           <QRIcon/>
                        </QRInfoPopper>
                     }
                  </Box>
               </Box>
            })}
         </div>
      </DialogContent>
   </Dialog>
}

type QRInfoPopperProps = {
   children: React.ReactNode | React.ReactNode[] | null;
}

const QRInfoPopper = ({children}: QRInfoPopperProps) => {
   const localizations = useRecoilValue(LocalizationsAtom);

   return <Tooltip
      title={localizations.dropoffQrInfo}
      arrow
      PopperProps={{
         sx: {
            '& .MuiTooltip-tooltip': {
               fontSize: '14px',
               padding: '12px 16px',
               maxWidth: '300px'
            }
         }
      }}
   >
      <IconButton size={"small"}>
         {children}
      </IconButton>
   </Tooltip>
}

const useStyles = makeStyles({
   buttonBackToStart: {
      marginTop: '50px',
      color: 'white'
   },
   box: {
      marginBottom: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
   },
   boxImage: {
      textAlign: 'center'
   },
   dialogContent: {
      minWidth: '400px'
   },
   '@media only screen and (max-width: 800px)': {
      dialogContent: {
         width: 'auto'
      }
   },

})
